<template>
    <div>
        <v-card-title class="text-h5 justify-center">
            {{ tableName }}
        </v-card-title>
        <v-flex class="d-flex justify-space-between">
            <!-- <div class="col-5">
                <v-text-field outlined dense v-model="companies.search" append-icon="mdi-magnify"
                    :label="$t('searchLabel')" single-line hide-details></v-text-field>
            </div> -->
            <v-spacer></v-spacer>
            <div>
                <v-dialog v-if="canAddNew" v-model="openPopup" max-width="1200px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="white--text" color="primary my-2" v-bind="attrs" v-on="on">
                            <v-icon left class="mr-4">
                                mdi-domain-plus
                            </v-icon> {{ $t('addNewLabel') }}
                        </v-btn>
                    </template>
                    <v-card class="pa-10">
                        <v-card-title>
                            <span class="headline">{{ $t('addAffiliateLabel') }}</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="newCompany.companyName" class="pa-0" hide-details="auto"
                                            outlined :label="$t('companyNameLabel')">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="newCompany.companyNumber" class="pa-0"
                                            hide-details="auto" outlined :label="$t('companyNumberLabel')">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="newCompany.countryCode" class="pa-0" hide-details="auto"
                                            outlined :label="$t('countryCodeLabel')">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="newCompany.postalCode" class="pa-0" hide-details="auto"
                                            outlined :label="$t('postalCodeLabel')">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="newCompany.address" class="pa-0" hide-details="auto"
                                            outlined :label="$t('addressLabel')">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="newCompany.city" class="pa-0" hide-details="auto"
                                            outlined :label="$t('companyCityLabel')">
                                        </v-text-field>
                                    </v-col>
                                    <template v-for="(user,index) in newCompany.users">
                                        <v-card width="100%" flat class="mb-4" :key="`us${index}`">
                                            <div class="text-right">
                                                <v-btn icon @click="removeUser(index)">
                                                    <v-icon>mdi-close</v-icon>
                                                </v-btn>
                                            </div>
                                            <v-row class="pa-4" :key="index">
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-text-field outlined v-model="user.FirstName"
                                                        :label="$t('nameFormLabel')" hide-details="auto"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-text-field outlined v-model="user.LastName"
                                                        :label="$t('surnameFormLabel')" hide-details="auto">
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-text-field outlined v-model="user.Email"
                                                        :label="$t('emailFormLabel')" hide-details="auto">
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-text-field outlined v-model="user.PersonalNumber"
                                                        :label="$t('personalNumberFormLabel')" hide-details="auto">
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-card>
                                    </template>
                                    <v-col cols="12 my-4 text-center" align-center justify-center>
                                        <v-btn color="primary text--white my-2" @click="addUser()" outlined>
                                            {{ $t('addUserLabel') }}
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="d-flex justify-center align-center">
                            <v-btn min-width="150" class="green white--text px-10" @click="registerCompany()">
                                {{ $t('saveCompanyLabel') }}
                            </v-btn>

                            <v-btn min-width="150" class="primary white--text px-2" color="" @click="openPopup = false">
                                {{ $t('cancelLabel') }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </v-flex>
        <v-data-table :options.sync="options" :footer-props="companies.footerProps" :server-items-length="1" :headers="companies.headers" :items="companies.values"
            :loading="loading" :loading-text="$t('tableLoadingLabel')">
            <template v-if="canModify" #item.actions="{ item }">
                <v-btn class="ml-4 primary--text" small outlined :to="{ name: 'AffiliateCompanyDetails' , params: { companyId: parentCompanyId, affiliateCompanyId: item.id} }">
                    {{$t('manageLabel')}}
                </v-btn>
            </template>
            <template v-slot:no-data>
                {{$t('noDataAvailable')}}
            </template>
            <template v-slot:no-results>
                {{$t('noDataAvailable')}}
            </template>
        </v-data-table>
        <v-pagination v-model="page" :length="pageCount" @input="getCompaniesByParent()"></v-pagination>
    </div>
</template>
<script>
    import UserTypes from '../auth/userTypes';
    export default {
        name: "AffiliatesCompanyTable",
        data() {
            return {
                options: {},
                page: 1,
                pageCount: 1,
                amount: 5,
                sortBy:'',
                sortDesc: null,
                syncLoading: false,
                openPopup: false,
                loading: true,
                newCompany: {
                    companyName: '',
                    countryCode: '',
                    postalCode: '',
                    city: '',
                    address: '',
                    users: [],
                    dateCreated: '',
                    parent: null,
                    companyNumber: ''
                },
                companies: {
                    search: '',
                    headers: [{
                            text: this.$t('salesNameLabel'),
                            value: 'name1',
                        },
                        {
                            text: this.$t('salesCountryCodeLabel'),
                            value: 'countryCode',
                        },
                        {
                            text: this.$t('salesCityLabel'),
                            value: 'city',
                        },
                        {
                            text: '',
                            sortable: false,
                            value: 'actions',
                            align: 'end'
                        },
                    ],
                    values: [],
                    footerProps:{
                        'items-per-page-options' : [5, 10, 15, 20, -1],
                        'disable-pagination': true,
                        'next-icon': null,
                        'prev-icon': null,
                        'page-text' : '',
                        'items-per-page-all-text': this.$t('allLabel'),
                        'items-per-page-text': this.$t('rowsPerPageLabel')
                    }
                },
                snackbar: {
                    show: true,
                    message: "",
                }
            }
        },
        props: {
            tableName: String,
            parentCompanyId: Number,
            canModify: Boolean,
            canAddNew: Boolean,
        },
        watch: {
            options: {
                handler(){
                    const options = this.options;
                    this.amount = options.itemsPerPage
                    const sortBy = options.sortBy.length > 0 ? options.sortBy[0] : '';
                    const sortDesc = options.sortDesc.length > 0 ? options.sortDesc[0] : null;
                    this.sortBy = sortBy;
                    this.sortDesc = sortDesc;
                    if (this.$props.parentCompanyId !== 0) {
                        this.getCompaniesByParent();
                    }
                },
                deep: true
            }
        },
        methods: {
            getCompaniesByParent() {
                this.axios.get('/api/company/getByParent', {
                    params: {
                        id: this.$props.parentCompanyId,
                        amount: this.amount,
                        page: this.page,
                        sortBy: this.sortBy,
                        sortDesc: this.sortDesc
                    }
                }).then(response => {
                    // console.log(response.data)
                    if (response.data != null){
                        this.pageCount = response.data.pages;
                        this.companies.values = response.data.companies;
                    }
                    this.loading = false
                }).catch(error => {
                    console.log(error)
                    this.loading = false
                });
            },
            addUser() {
                const userObject = {
                    FirstName: '',
                    LastName: '',
                    Email: '',
                    UserType: UserTypes.AffiliatePartnershipSales,
                    PersonalNumber: ''
                }
                this.newCompany.users.push(userObject);
            },
            removeUser(index) {
                this.newCompany.users.splice(index, 1);
            },

            registerCompany() {
                var data = {
                    CompanyName: this.newCompany.companyName,
                    CountryCode: this.newCompany.countryCode,
                    PostalCode: this.newCompany.postalCode,
                    Address: this.newCompany.address,
                    Parent: this.$store.state.user.companyId,
                    City: this.newCompany.city,
                    Users: this.newCompany.users,
                    CompanyNumber: this.newCompany.companyNumber
                }
                this.axios.post('api/company/createCompanyWithUsers', data).then(response => {
                    this.companies.values.push(response.data);
                    this.openPopup = false;
                    this.newCompany = this.getDefaultNewCompanyState();
                    this.snackbar.message = response.data
                    this.$EventBus.$emit("snackbar", this.snackbar);
                }).catch(error => {
                    this.loading = false
                    this.snackbar.message = error.message
                    this.$EventBus.$emit("snackbar", this.snackbar);
                });
            },

            getDefaultNewCompanyState() {
                return {
                    companyName: '',
                    countryCode: '',
                    postalCode: '',
                    city: '',
                    address: '',
                    users: [],
                    dateCreated: '',
                    parent: null,
                    companyNumber: ''
                }
            }
        },
        mounted() {
            if (this.$props.parentCompanyId !== 0) {
                this.getCompaniesByParent();
            }
        }
    }
</script>
<style scoped>

</style>